<template>
  <div
    class="search-input-container"
    v-on:click.stop
  ></div>
</template>

<script>
import '@septima/septima-search/src/css/defaultView.css';
import { setupSearch } from '@/septimaSearch';
export default {
  name: 'search-searcher',
  data() {
    return {
      view: null,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  props: {
    kommunekode: String,
  },
  methods: {
    onSelected(result) {
      this.$emit('result', result);
    },
    onError(error) {
      this.$emit('error', error);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.view != null && this.view.top() != null) {
        this.view.setMaxHeight(this.window.height - this.view.top() - 40);
      }
    },
  },
  mounted() {
    this.view = setupSearch(
      this.$el,
      this.onSelected,
      this.onError,
      this.kommunekode
    );
    this.view.myInputField[0].placeholder =
      'Søg efter adresse eller klik i kort ...';
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang=scss>
.search-input-container {
  width: 100%;
  width: calc(100% - 75px);
  border: 1px solid transparent;
  margin: 0 15px 0 20px;
  background-color: $default-color-background-light;
  border-radius: 5px;
}

.septimasearch .ssSearchBackground input.ssInput {
  color: $primary-700;
}

.septimasearch .ssSearchHeader .ssSearchBackground,
.septimasearch .ssSearchBackground input.ssInput,
.septimasearch .ssSearchBackground .ssSearchIcon,
.septimasearch .ssSearchBackground .ssCloseButton,
.septimasearch .ssSearchBackground .ssSpinner {
  height: 46px;
  line-height: normal;
}

.septimasearch .ssSearchHeader .ssSearchBackground {
  display: flex;
  align-items: center;
}

.septimasearch .ssSearchResult {
  width: 80%;
  width: calc(100% - 102px);
  position: absolute;
  top: 64px;
  left: 28px;
  border: none;
  box-shadow: 0 0 8px 0 rgba(175, 186, 213, 0.3);
  background-color: $default-color-background-light;
}

.search-input-container.ssActive {
  border-radius: 5px;
  border: 1px solid #e4e6f0;
  box-shadow: none;
  outline: none;
}

.septimasearch .ssSearchBackground input.ssInput::placeholder {
  color: #969bc0;
  opacity: 1;
  font-weight: 500;
}

.septimasearch .ssSearchBackground input.ssInput:-ms-input-placeholder {
  color: #969bc0;
}

.septimasearch .ssSearchBackground input.ssInput::-ms-input-placeholder {
  color: #969bc0;
}

.septimasearch ul.better-autocomplete > li.result {
  color: $primary-500;
}

.septimasearch ul.better-autocomplete > li.result.highlight {
  background-color: #fff;
  color: $primary-700;
}

.septimasearch .ssTargetbit .ssTargetlabel,
.septimasearch .ssTargetbit .ssTargetclosebutton {
  background-color: $primary-700;
  font-weight: 700;
}

.septimasearch .ssTargetbit {
  padding-right: 6px;
}

.septimasearch .ssSearchBackground .ssSearchIcon {
  background-image: none;
  opacity: 0.7;
  top: 0;
}

.septimasearch .ssSearchBackground .ssSearchIcon:before {
  content: '';
  position: absolute;
  top: 13px;
  left: 12px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid #7179aa;
}

.septimasearch .ssSearchBackground .ssSearchIcon:after {
  content: '';
  position: absolute;
  top: 25px;
  left: 26px;
  display: block;
  height: 8px;
  width: 1px;
  border-right: 2px solid #7179aa;
  transform: rotate(-45deg);
}

.septimasearch.ssActive .ssSearchBackground .ssSearchIcon {
  opacity: 1;
}

.septimasearch .ssSearchBackground .ssCloseButton {
  opacity: 0.6;
}
</style>
